import { useMemo } from 'react';

export const useSelectorFactory = <
  T extends (...args: any[]) => any
>(selectorFactory: T, args: Parameters<T>): ReturnType<T> =>
  useMemo(() => selectorFactory(...args), args);
